import { useEffect, useRef } from 'react';

function useUnmount(fn: VoidFn) {
    const ref = useRef<VoidFn>(() => {
        throw new Error('Cannot call an event handler while rendering.');
    });

    // update the ref each render so if it change the newest callback will be invoked
    ref.current = fn;

    useEffect(() => () => ref.current(), []);
}

export default useUnmount;
